module.exports = __webpack_public_path__ + "static/BatisseurDAvenir-74eb050f6c9e5891288b8fe5f94f63ab.png";